import '../../Style/product/fill-form.css';
import { t } from 'i18next';
import { formatYYYYMMDDToDDMMYYYY, isNullOrEmpty } from '../../Services/service.js';
import CustomCheckBox from '../../Components/custom-checkbox/CustomCheckBox.js';
import { useEffect, useState } from 'react';
import OtpPhoneDialogWidget from '../../Widgets/otp-dialog/OtpPhoneDialogWidget.js';
import CustomButtonColor from '../../Components/custom-button/CustomButtonColor.js';
import { previousStep, sendOtpEkyc } from '../../Services/api-service.js';
function EkycSection({objectDto,  province, ward, contactWard, occupation, setLoading, setObjectDto}){
    const [checked, setChecked] = useState(false);
    const handlePreviousStep=()=>{
        setLoading(true);
        window.scrollTo(0, 0);
        return previousStep(objectDto, setObjectDto, setLoading);
    }
    const handleOtpEkyc = () => {
        localStorage.removeItem("####");
        window.scrollTo(0,0);
        setLoading(true);
        sendOtpEkyc(objectDto, setObjectDto, setLoading);
        // this one is for test performance - infras
        // setObjectDto({...objectDto, step: 7});
    }
    useEffect(()=>{
        document.body.style.overflow = "auto";
    },[]);
    return (
        <>
        <section className="confirm-information">
            <div className="container-confirm-information">
                <div className="confirm-information-wrapper">
                    <div className="confirm-infor-form">
                        <div className="title-confirm-infor-wrap" style={{textAlign:"center"}}>
                            <h2 className="title-font-confirm-infor">EKYC</h2>
                        </div>
                        
                        <div className='border-form-group-confirm-information'>
                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line two-column">
                                    <label className='lbl-wbox'>{t("fullnamefill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.fullName}</label>
                                </div>
                                
                                <div className="form-group-confirm-information same-line two-column">
                                    <label className='lbl-wbox'>{t("emailfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.email}</label>    
                                </div>
                            </div>
                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("birthfill")}</label>
                                    <label className='lbl-wbox-value'>{formatYYYYMMDDToDDMMYYYY(objectDto.dob)}</label>
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("genderfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.gender === 0 ? t("gendermale") : t("genderfemale")}</label>                            
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("phonenumberfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.phoneNumber}</label>
                                </div>
                            </div>

                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("birthplacefill")}</label>
                                    <label className='lbl-wbox-value'>
                                        { 
                                            !isNullOrEmpty(province) ? province.map((item)=>{
                                                if(item.code === objectDto.birthPlace) return item.name;
                                            }) 
                                            : 
                                            <></>
                                        }
                                    </label>
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("occupationfill")}</label>
                                    <label className='lbl-wbox-value'>
                                        { 
                                            !isNullOrEmpty(occupation) ? occupation.map((item)=>{
                                                if(item.id === objectDto.occupationId) return item.descriptionVn;
                                            }) 
                                            : 
                                            <></>
                                        }
                                    </label>
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("maritalfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.married === "0" ? t("singlemarital") : t("marriagemarital")}</label>
                                </div>
                            </div>
                            
                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("idfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.idnumber}</label>    
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("dateidfill")}</label>
                                    <label className='lbl-wbox-value'>{formatYYYYMMDDToDDMMYYYY(objectDto.iddate)}</label>  
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("placeidfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.idplace}</label>  
                                </div>
                            </div>
                            
                            <div className="form-group-confirm-information same-line">
                                <label className='lbl-wbox'>{t("addressfill")}</label>
                                <label className='lbl-wbox-value'>
                                    {
                                        objectDto.address + ", " +
                                        ( !isNullOrEmpty(ward) 
                                            ? ward.map((item) => {
                                                if (item.code === objectDto.wardCode) return item.name;
                                                return null;
                                            }).filter((name) => name !== null).join(", ") 
                                            : "" 
                                        // ) + ", " +
                                        // ( !isNullOrEmpty(district) 
                                        //     ? district.map((item) => {
                                        //         if (item.code === objectDto.districtCode) return item.name;
                                        //         return null;
                                        //     }).filter((name) => name !== null).join(", ") 
                                        //     : "" 
                                        ) + ", " +
                                        ( !isNullOrEmpty(province) 
                                            ? province.map((item) => {
                                                if (item.code === objectDto.provinceCode) return item.name;
                                                return null;
                                            }).filter((name) => name !== null).join(", ") 
                                            : "" 
                                        ) + "."
                                    } 
                                </label>
                            </div>
                            
                            <div className="form-group-confirm-information same-line">
                                <label className='lbl-wbox'>{t("addresscontactfill")}</label>
                                <label className='lbl-wbox-value'>
                                {
                                    objectDto.contactAddress + ", " +
                                    ( !isNullOrEmpty(contactWard) 
                                        ? contactWard.map((item) => {
                                            if (item.code === objectDto.contactWardCode) return item.name;
                                            return null;
                                        }).filter((name) => name !== null).join(", ") 
                                        : "" 
                                    // ) + ", " +
                                    // ( !isNullOrEmpty(contactDistrict) 
                                    //     ? contactDistrict.map((item) => {
                                    //         if (item.code === objectDto.contactDistrictCode) return item.name;
                                    //         return null;
                                    //     }).filter((name) => name !== null).join(", ") 
                                    //     : "" 
                                    ) + ", " +
                                    ( !isNullOrEmpty(province) 
                                        ? province.map((item) => {
                                            if (item.code === objectDto.contactProvinceCode) return item.name;
                                            return null;
                                        }).filter((name) => name !== null).join(", ") 
                                        : "" 
                                    ) + "."
                                } 
                                </label>
                            </div>
                        </div>

                        <div className="title-confirm-infor-wrap">
                            <div className='header-title-rule-confirm' style={{backgroundColor:"transparent"}}>
                                <CustomCheckBox value={checked} text={<h2 className='title-font-rule-confirm'>Tôi đồng ý eKYC với những thông tin trên</h2>} 
                                setValue={()=>{
                                    setChecked(!checked);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="wrap-list-button">
            <CustomButtonColor title={t("return")} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handlePreviousStep}/>
            <CustomButtonColor title={t("sendotpphone")} color={checked ? "white" : "black"} borderRadius={"5px"} bgColor={checked ? "#c59812" : "#F2F2F7"} onClick={checked ? handleOtpEkyc : ()=>{}}/>
        </div>
        
        {
            isNullOrEmpty(objectDto.sendVerifyPhone) || objectDto.sendVerifyPhone === 0 ? 
            <></>:
        <OtpPhoneDialogWidget objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading}/>
        }
    </>
    );
}
export default EkycSection;